<template>
  <div class="patterns_wrapper">
    <h2 v-if="withTitle" class="main_title">{{localization('Your Learning Pattern Combination')}}</h2>
    <!-- <p class="subtitle">{{localization('Pattern Combination Explanation')}}</p> -->
<!-- Patterns -->
    <div class="d-flex justify-content-end" v-if="!hideActions">
      <div
        class="d-flex justify-content-end plc_hide_while_printing"
      > 
      <!-- Print Student Notebook Button -->
      <el-tooltip
        v-if="showPrintNotebook && hasPermission('print student notebook')"
        class="mb-2 edit-btn print-btn main_tool_tip"
        :content="`${localization('Print Student Notebook')}`"
        placement="top-start"
      >
        <el-button
          type="success"
          @click="$emit('print-notebook')"
        >
          <i class="fa fa-print" style="font-size: 20px"></i>
        </el-button>
      </el-tooltip>
      <!-- End Print Student Notebook Button -->
      <el-tooltip
          v-if="hasPermission('show_qrcode')"
          class=" mb-2 edit-btn print-btn main_tool_tip"
          :content="`${localization('Organization QR')}`"
          placement="top-start"
        >
          <el-button
            v-if="hasPermission('admin_institutions') || hasPermission('manage_institutions')"
            @click="downloadQRCode(user.organization_promo_code)"
            class="mb-2 edit-btn edit_score_button"
            >
            <img class="img" src="@/assets/new-theme/qr1.png" alt="" />
          </el-button>

        </el-tooltip>
        <el-tooltip
          v-if="hasPermission('edit_users')"
          class=" mb-2 edit-btn print-btn main_tool_tip"
          :content="`${localization('Edit Score')}`"
          placement="top-start"
        >
          <el-button
            v-if="hasPermission('access_users') || hasPermission('edit_users')"
            @click="open_score_dialog"
            class="mb-2 edit-btn edit_score_button"
            >
            <img class="img" src="@/assets/new-theme/edit-05.png" alt="" />
          </el-button>

        </el-tooltip>
        <el-tooltip
          v-if="hasPermission('edit_roles')"
          class=" mb-2 edit-btn print-btn main_tool_tip"
          :content="`${localization('View Role')}`"
          placement="top-start"
        >
          <el-button
            @click="$router.push(`/permissions/${user.id}`)"
            v-if="hasPermission('show_roles')"
            class="mb-2 edit-btn "
            type="info"
          >
            <i class="fa fa-lock" style="font-size: 20px; color: #fff "></i>
          </el-button>
        </el-tooltip>

        <!-- <el-tooltip
          v-if="hasPermission('edit_lci')"
          class=" mb-2 edit-btn print-btn main_tool_tip"
          :content="`${localization('View LCI')}`"
          placement="top-start"
        > -->
        <el-tooltip
          v-if="hasPermission('show_lci')"
          class=" mb-2 edit-btn print-btn main_tool_tip"
          :content="`${localization('View LCI')}`"
          placement="top-start"
        >
        <el-button
            v-if="hasPermission('show_lci')"
            class="py-3"
            type="warning"
            @click="$router.push(`/new-theme/questions/${user.id}`)"
            ><i class="fa fa-question-circle" style="font-size: 20px" ></i>
          </el-button>
        </el-tooltip>


        <el-tooltip
          v-if="hasPermission('show_tasks')"
          class=" mb-2 edit-btn print-btn main_tool_tip"
          :content="`${localization('View tasks')}`"
          placement="top-start"
        >
          <el-button
            type="primary"
            @click="edit_tasks_dialog = true"
            v-if="hasPermission('show_tasks')"
          >
            <i class="fa fa-tasks" style="font-size: 20px"></i>
          </el-button>
        </el-tooltip>

      </div>
    </div>
    <div>
      <div class="wrapper_for_pattern" v-if="patterns">
        <div
          class="main_pattern_card"
          v-for="(item, i) in patterns"
          :key="i"
        >
          <div
            :style="`background-color : ${getProgressColor(item.name)}`"
            :class="[`part_one`, item.visible === false ? 'round_card' : '']"
          >
            <div>
              <span class="pattern_name">{{ item.name_short }}</span>
            </div>
            <div class="numbers_wrapper">
              <span class="number">{{validScore ? item.number : null}} </span>
              <span class="number_key">{{validScore ? item.number_key : '-' }}</span>
            </div>
            <div class="d-flex justify-content-center ">
              <img
                v-if="item.visible == true"
                @click="hideCardDetails(i)"
                role="button"
                src="../../../assets/new-theme/profile/chevron-down.png"
                alt=""
              />
              <img
                v-if="item.visible == false"
                @click="hideCardDetails(i)"
                role="button"
                src="../../../assets/new-theme/profile/chevron-down-under.png"
                alt=""
              />
            </div>
          </div>
          <div :class="['part_two', item.visible === true ? 'border_card' : '']" v-if="item.visible">
            <div>
              <span class="pattern_name">{{ item.second_title }}</span>
            </div>
            <ul class="list_items">
              <li
                class="item_in_list mt-1"
                v-for="(pat, index) in item.items"
                :key="index"
              >
                {{ pat }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="`${localization('Edit score')}`"
      :visible.sync="score_dialog"
      width="600px"
      top="1%"
      custom-class="task-modal global_modal"
      @close="score_dialog = false"
      :close-on-click-modal="false"
    >
      <div class="custom_modal_header">
        <div class="images">
          <img src="@/assets/new-theme/edit-05-icon.png" alt="file" />
          <img
            @click="score_dialog = false"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title">
          {{ localization("Add a new study-related task") }}
        </h3>
        <p class="description">
          {{ localization("Add your own task and discover what patterns are needed to successfully complete it.") }}
        </p>
      </div>

      <!-- Task Form -->
      <el-form
        :model="score"
        class="p-2"
        label-position="top"
        @submit.prevent="save"
      >
        <el-form-item :label="`${localization('Sequence')}`">
          <el-input-number
            :min="7"
            :max="35"
            v-model="score.sequence"
            :placeholder="`${localization('Sequence')}`"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <!-- percision  -->
        <el-form-item :label="`${localization('precision')}`">
          <el-input-number
            :min="7"
            :max="35"
            v-model="score.precision"
            :placeholder="`${localization('precision')}`"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <!-- technical reasoning  -->
        <el-form-item :label="`${localization('Technical Reasoning')}`">
          <el-input-number
            :min="7"
            :max="35"
            v-model="score.technical_reasoning"
            :placeholder="`${localization('Technical Reasoning')}`"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <!-- confluence  -->
        <el-form-item :label="`${localization('Confluence')}`">
          <el-input-number
            :min="7"
            :max="35"
            v-model="score.confluence"
            :placeholder="`${localization('Confluence')}`"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
      </el-form>

      <!-- Footer Buttons -->
      <div class="lci_modal_buttons mt-4">
        <button @click="score_dialog = false" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="save" class="lci_btn save  lci_btn_modal_cancel">
          {{ localization("Save") }}
        </button>
      </div>
    </el-dialog>

    <el-dialog
      :title="localization('Tasks')"
      :visible.sync="edit_tasks_dialog"
      top="4vh"
      width="90%"
      append-to-body
      class="for_user_edit_details_dialog"
    >
      <ForShowUserProfile :hideScoreAndInstructions="true" />
      <!-- <Index :hideScoreAndInstructions="true" /> -->
    </el-dialog>
  </div>
</template>

<script>
import ForShowUserProfile from "@/views/tasks/ForShowUserProfile.vue";
export default {
  name: "UserPattern",
  props: {
    withTitle: {
      type: Boolean,
      default: true,
      required: false
    },
    userScore: {
      type: Object,
      required: false
    },
    validScore: {
      type: Boolean,
      required: false,
      default: true
    },
    visible: {
      type: Boolean,
      default: false,
      required: false
    },
    showPrintNotebook: {
      type: Boolean,
      default: false,
      required: false
    },
    hideActions: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    ForShowUserProfile
  },
  computed: {
    user: function() {
      return this.$store.state.user.user;
    },
  },
  data() {
    return {
      edit_tasks_dialog: false,
      score: {},
      patterns:[ ],
      score_dialog: false,
      test: ""
    };
  },
  methods: {
    getProgressColor(key) {
      switch (key) {
        case "Precision":
          return "#3c3";
        case "Technical Reasoning":
          return "#f93";
        case "Confluence":
          return "#c36";
        case "Sequence":
          return "#39c";
      }
    },
    hideCardDetails(index) {
      this.patterns[index].visible = !this.patterns[index].visible;
    },
    async downloadQRCode(promoCode) {
      const url = `${process.env.VUE_APP_FRONT_URL}register-basic?code=${promoCode}`;

      const QRCode = (await import('qrcode')).default;
      try {

        const qrDataUrl = await QRCode.toDataURL(url, { width: 300 });

        const link = document.createElement('a');
        link.href = qrDataUrl;
        link.download = `organization-qr.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error('Failed to generate QR code:', err);
      }
    },
    open_score_dialog() {
      this.score = { ...this.userScore };
      this.score_dialog = true;
    },
    save() {
      // this.$refs["edit_score_rules"].validate(valid => {
      //   if (valid) {
      this.$store
        .dispatch("user/save", {
          id: `/${this.user.id}`,
          query: this.score
        })
        .then(_ => {
          window.location.reload();
          this.score_dialog = false;
          Swal.fire({
            title: "",
            text: `${this.localization("Done")}`,
            confirmButtonText: `${this.localization("Ok")}`,
            icon: "success",
            confirmButtonClass: "btn btn-success ",
            buttonsStyling: false
          });
        });
      //   }
      // });
    },
    handlePatterns() {
      this.patterns = [ {
          name: "Sequence",
          name_short: this.localization("Sequence (S)"),
          number: "-",
          number_key: "-",
          second_title: this.localization("Sequential Learning Patterns") ,
          visible: false,
          items: [
            this.localization("Organizes life") ,
            this.localization("Makes Lists") ,
            this.localization("Lives by schedules") ,
            this.localization("Makes extensive plans") ,
          ]
        },
        {
          name: "Precision",
          name_short: this.localization("Precision (P)") ,
          number: "-",
          number_key: "-",
          second_title: this.localization("Precision Learning Patterns") ,
          visible: false,
          items: [
            this.localization("Relishes information") ,
            this.localization("Seeks facts") ,
            this.localization("Must be right") ,
            this.localization("Provides detailed responses") ,
          ]
        },
        {
          name: "Technical Reasoning",
          name_short: this.localization("Technical Reasoning (T)") ,
          number: "-",
          number_key: "-",
          second_title: this.localization("Technical Learning Patterns") ,
          visible: false,
          items: [
            this.localization("Solves problems") ,
            this.localization("Uses few words") ,
            this.localization("Looks for relevance and practicality") ,
            this.localization("Works alone") ,
          ]
        },
        {
          name: "Confluence",
          name_short: this.localization("Confluence (C)") ,
          number: "-",
          number_key: "-",
          second_title: this.localization("Confluence Learning Patterns") ,
          visible: false,
          items: [
            this.localization("Takes risks") ,
            this.localization("Sees the big picture") ,
            this.localization("Embraces innovation") ,
            this.localization("Initiates change") ,
          ]
        }
      ];

      this.patterns.forEach(pattern => {
        if (pattern.name == "Sequence") {
          pattern.number = this.userScore?.sequence;
          // Start Pattern range
          if (this.userScore?.sequence >= 25 && this.userScore.sequence <= 35) {
            pattern.number_key = this.localization("Use First");
          } else if (
            this.userScore?.sequence >= 7 &&
            this.userScore.sequence <= 17
          ) {
            pattern.number_key = this.localization("Avoid");
          } else if (
            this.userScore?.sequence >= 18 &&
            this.userScore.sequence <= 24
          ) {
            pattern.number_key = this.localization("As Needed");
          }
          // End Pattern range
        }
        if (pattern.name == "Precision") {
          pattern.number = this.userScore?.precision;
          // Start Pattern range
          if (
            this.userScore?.precision >= 25 &&
            this.userScore.precision <= 35
          ) {
            pattern.number_key = this.localization("Use First");
          } else if (
            this.userScore?.precision >= 7 &&
            this.userScore.precision <= 17
          ) {
            pattern.number_key = this.localization("Avoid");
          } else if (
            this.userScore?.precision >= 18 &&
            this.userScore.precision <= 24
          ) {
            pattern.number_key = this.localization("As Needed");
          }
          // End Pattern range
        }
        if (pattern.name == "Technical Reasoning") {
          pattern.number = this.userScore?.technical_reasoning;
          // Start Pattern range
          if (
            this.userScore?.technical_reasoning >= 25 &&
            this.userScore.technical_reasoning <= 35
          ) {
            pattern.number_key = this.localization("Use First");
          } else if (
            this.userScore?.technical_reasoning >= 7 &&
            this.userScore.technical_reasoning <= 17
          ) {
            pattern.number_key = this.localization("Avoid");
          } else if (
            this.userScore?.technical_reasoning >= 18 &&
            this.userScore.technical_reasoning <= 24
          ) {
            pattern.number_key = this.localization("As Needed");
          }
          // End Pattern range
        }
        if (pattern.name == "Confluence") {
          pattern.number = this.userScore?.confluence;
          // Start Pattern range
          if (
            this.userScore?.confluence >= 25 &&
            this.userScore.confluence <= 35
          ) {
            pattern.number_key = this.localization("Use First");
          } else if (
            this.userScore?.confluence >= 7 &&
            this.userScore.confluence <= 17
          ) {
            pattern.number_key = this.localization("Avoid");
          } else if (
            this.userScore?.confluence >= 18 &&
            this.userScore.confluence <= 24
          ) {
            pattern.number_key = this.localization("As Needed");
          }
          // End Pattern range
        }
      });
    },
    setAllPatternsVisible() {
      // Set all pattern items' visible property to true
      this.patterns.forEach(pattern => {
        pattern.visible = true;
      });
    }
  },

  watch: {
    userScore: {
      handler(newVal) {
        if (newVal) {
          this.handlePatterns(); // Call the function when userScore has a value
        }
      },
      immediate: true // If you want the watcher to trigger immediately when the component is mounted and `userScore` already has a value
    },
    visible: {
      handler(newVal) {
        if (newVal === true) {
          this.setAllPatternsVisible(); // Call a function to make all patterns visible
        }
      },
      immediate: true // Run the watcher on initial mount if visible is true
    }
  }
};
</script>

<style lang="scss" scoped>
// Use Your Learning Patterns
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0px !important;
  margin: 0px !important;
}
.main_title {
  color: #101828;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 10px;
  &.white_text {
    color: #fff;
  }
}
.subtitle {
  color: #667085;
  font-size: 14px;
  margin-top: 0px; 
  margin-bottom: 5px;
  max-width: 700px;
}
.patterns_wrapper {
  .wrapper_for_pattern {
    display: flex;
    justify-content: space-between;
    gap: 1.5%;
    flex-wrap: wrap; // Added for tablet responsiveness

    @media (max-width: 991px) {
      gap: 15px;
    }
  }
    .main_pattern_card {
      border-radius: 8px;
      width: calc(94% / 4);
      border: 1px solid transparent;

      @media (max-width: 1200px) {
        width: calc(96% / 2);
        margin-bottom: 5px;
      }

      @media (max-width: 575px) {
        width: 100% !important;
      }
      .part_one {
      padding: 15px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      border: 1px solid transparent;
      &.round_card {
        border-radius: 8px;
        border: 1px solid #eaecf0;
      }
      .pattern_name {
        font-weight: 500;
        font-size: 17px;
        color: #fff;
        margin-bottom: 15px;
        display: block;
      }
      .numbers_wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .number {
          font-weight: 500;
          font-size: 48px;
          color: #fff;
        }
        .number_key {
          font-weight: 500;
          font-size: 17px;
          color: #fff;
        }
      }
    }
    .part_two {
      padding: 15px;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      box-shadow: 0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814;
      .pattern_name {
        font-weight: 500;
        font-size: 17px;
        color: #344054;
      }
      .list_items {
        margin-bottom: 0 !important;
        margin-left: 0;
        padding-left: 17px;
      }
      .item_in_list {
        font-weight: 400;
        font-size: 16px;
        color: #667085;
      }
      &.border_card {
        border: 1px solid #eaecf0;
      }
    }
  }
}
.img {
  display: block;
  width: 100%;
  height: 100px;
}
.edit_score_button{
  background-color: #f9f5ff;
  color: #101828;
  border: unset !important;
  img{
    width: 20px;
    height: 20px;
  }
}

.your_personal_wrapper {
    margin-top: 40px;
    border-radius: 8px;
    border: 1px solid #eaecf0;
    padding: 24px;
    .text {
      color: #667085;
      font-weight: 400;
      font-size: 16px;
    }
    .lci_btn {
      border-radius: 8px;
      padding: 12px 20px;
      border: 1px solid #eaecf0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 240px;
      font-weight: 500;
      font-size: 16px;
      background-color: #7f56d9;
      color: #fff;
      &.save {
      }
    }
  }

@media (max-width: 768px){
  .patterns_wrapper .main_pattern_card .part_one .numbers_wrapper .number{
    font-size: 33px !important;
  }
  .patterns_wrapper .main_pattern_card .part_one .pattern_name{
    font-size: 12px !important;
  }
  .patterns_wrapper .main_pattern_card .part_one .numbers_wrapper .number_key{
    font-size: 13px !important;
  }
}

@media (max-width: 575px) {
   .patterns_wrapper {
    .plc_hide_while_printing{
      display: block !important;
    }
    .wrapper_for_pattern{
      display: block !important;
      width: 100% !important;
      .main_pattern_card{
        width: 100% !important;
      }
    }
  }
}

@media print {
  .patterns_wrapper {
    .wrapper_for_pattern {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      justify-content: space-between !important;
      gap: 1% !important;
      width: 100% !important;
    }
    .main_pattern_card {
      width: calc(96% / 4) !important;
      margin-bottom: 0 !important;
      display: block !important;
      
      .part_one {
        padding: 10px !important;
        .pattern_name {
          font-size: 13px !important;
          margin-bottom: 8px !important;
        }
        .numbers_wrapper {
          .number {
            font-size: 28px !important;
          }
          .number_key {
            font-size: 12px !important;
          }
        }
      }
    }
  }
}
</style>
